import { MasterInstance } from "@/instance/axios";
import { AuthSignupPost201Response } from "@sizlcorp/sizl-api-document/dist/models";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export const WHO_AM_I_KEY = "whoamI";

const fetchAuthWhoamiGet = () => MasterInstance.authWhoamiGet();

export const useAuthWhoamiGet = (options?: {
  onSuccess: (data: AuthSignupPost201Response) => void;
}) => {
  return useQuery([WHO_AM_I_KEY], () => fetchAuthWhoamiGet(), {
    select: (data: AxiosResponse<AuthSignupPost201Response, any>) =>
      data.data as AuthSignupPost201Response,
    onSuccess: (data) => {
      options?.onSuccess(data);
    },
  });
};
